import { Video } from 'lucide-react';
import { cn } from '@/lib/cn';

/**
 * "Recording" as an icon and a word, not a status chip (design eval P8, F31).
 * As an outline state chip it sat beside the session's own status chip in the
 * same shape, ΔE00 1.2 (protan) from "active" in dark. Recording is an activity,
 * not a state, so it takes the secondary text colour and a glyph instead.
 */
export function RecordingIndicator({ label = 'Recording', className }: { label?: string; className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-1 text-micro font-medium text-[var(--d2d-text-secondary)]', className)}>
      <Video size={14} aria-hidden="true" />
      {label}
    </span>
  );
}
